import { ChangeDetectionStrategy, Component, computed, inject, input, Signal } from '@angular/core';

import { EventSeverityDisplayComponent } from '@iot-platform/iot-platform-ui';
import { DateFormatPipe } from '@iot-platform/pipes';
import { TranslateService } from '@ngx-translate/core';
import { Asset } from '@iot-platform/models/i4b';

@Component({
  selector: 'iot4bos-ui-asset-status-chip',
  imports: [EventSeverityDisplayComponent],
  template: ` <iot-platform-ui-event-severity-display
    data-cy="asset-info-status"
    [severity]="$safeNavigationMigration(asset()?.status?.name)"
    [tooltip]="statusTooltip()"
  />`,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DateFormatPipe]
})
export class StatusChipComponent {
  private readonly dateFormatPipe = inject(DateFormatPipe);
  private readonly translateService = inject(TranslateService);

  asset = input.required<Asset>();

  statusTooltip: Signal<string | null> = computed(() => {
    const asset = this.asset();
    const updatedAt = asset?.status?.datetime ? this.dateFormatPipe.transform(asset.status?.datetime) : null;
    const switchBackDate = asset?.status?.scheduledMaintenance?.active
      ? this.dateFormatPipe.transform(asset.status?.scheduledMaintenance?.switchbackDate)
      : null;
    return updatedAt && switchBackDate
      ? this.translateService.instant('IOT_DICTIONARY.SINCE') +
          ' : ' +
          updatedAt +
          ' \n ' +
          this.translateService.instant('IOT_DICTIONARY.SWITCH_BACK') +
          ' : ' +
          switchBackDate
      : updatedAt
        ? this.translateService.instant('IOT_DICTIONARY.SINCE') + ' : ' + updatedAt
        : null;
  });
}
